export const syntaxCheck = `query syntaxCheck($kmatID: String!,$modVer: String!) {
  syntaxCheck(kmatID: $kmatID,modVer: $modVer) 
  }`;
